import { ref, getCurrentInstance } from '@vue/composition-api'
import { getUserPaymentMethods } from '@api'
import { useUtils } from '@core/libs/i18n'
import useCryptoJs from '@core/utils/useCryptoJs'

export default function useGame() {
  const vm = getCurrentInstance().proxy
  const { decryptData } = useCryptoJs()
  const { tInContext } = useUtils()

  const paymentMethods = ref([])

  const fetchPaymentMethods = async () => {
    try {
      const response = await getUserPaymentMethods()
      if (response.ok) {
        paymentMethods.value = decryptData(response.data)
        paymentMethods.value.unshift({
          id: 0,
          last_4: null,
          exp_month: null,
          exp_year: null,
          brand: 'Add new card',
          exp_date_str: null,
        })
      }
    } catch (e) {
      console.error(e)
      paymentMethods.value = []
    }
  }

  const sortByTPR = array => array.sort((a, b) => {
    const tprA = a.tpr === null ? 0 : a.tpr
    const tprB = b.tpr === null ? 0 : b.tpr

    return tprA - tprB
  })

  const getTeamsName = (myTeams, myTeam, hasTeam = null, isChallenge = false) => {
    const myTeamA = myTeams.find(e => e.letter === 'A')
    const myTeamB = myTeams.find(e => e.letter === 'B')

    let teamAName = myTeamA && isChallenge ? myTeamA.name : `${tInContext('game.team', vm)} A`
    let teamBName = myTeamB && isChallenge ? myTeamB.name : `${tInContext('game.team', vm)} B`

    const teamShield = require('@/assets/images/svg/team-shield.svg')
    const teamAShield = myTeamA && myTeamA.logo ? myTeamA.logo : teamShield
    const teamBShield = myTeamB && myTeamB.logo ? myTeamB.logo : teamShield

    if (hasTeam) {
      if (myTeam === 'A' && isChallenge) {
        teamAName = myTeamA ? myTeamA.name : `${tInContext('game.my_team', vm)}`
        teamBName = myTeamB ? myTeamB.name : `${tInContext('game.rival_team', vm)}`

        // teamAShield = myTeamA ? myTeamA.logo : teamShield
        // teamBShield = myTeamB ? myTeamB.logo : teamShield
      }

      if (myTeam === 'B' && isChallenge) {
        teamAName = myTeamA ? myTeamA.name : `${tInContext('game.rival_team', vm)}`
        teamBName = myTeamB ? myTeamB.name : `${tInContext('game.my_team', vm)}`

        // teamAShield = myTeamA ? myTeamA.logo : teamShield
        // teamBShield = myTeamB ? myTeamB.logo : teamShield
      }
    }

    return {
      teamAName,
      teamBName,

      teamAShield,
      teamBShield,
    }
  }

  const getTeamName = (myTeams, myTeam, hasTeam = null, isChallenge = false) => {
    const { teamAName, teamBName } = getTeamsName(myTeams, myTeam, hasTeam, isChallenge)

    return myTeam === 'A' ? teamAName : teamBName
  }

  const getTeamShield = (myTeams, myTeam, hasTeam = null, isChallenge = false) => {
    const { teamAShield, teamBShield } = getTeamsName(myTeams, myTeam, hasTeam, isChallenge)

    return myTeam === 'A' ? teamAShield : teamBShield
  }

  const mapTeams = (playersA, playersB, team = null, myTeam = null, myTeams = [], isChallenge = false) => {
    if (!playersA || !playersA || playersA.length === 0 || playersB.length === 0) return []

    const {
      teamAName, teamBName, teamAShield, teamBShield,
    } = getTeamsName(myTeams, myTeam, myTeam, isChallenge)

    const teams = [
      {
        id: 'A',
        players: playersA.some(e => e.tpr !== null) ? sortByTPR(playersA) : playersA,
        my_team: team === 'A',
        name: teamAName,
        logo: teamAShield,
      },
      {
        id: 'B',
        players: playersB.some(e => e.tpr !== null) ? sortByTPR(playersB) : playersB,
        my_team: team === 'B',
        name: teamBName,
        logo: teamBShield,
      },
    ]

    if (isChallenge && (myTeams.length === 1 || myTeam === 'B' || team === 'B')) return teams.reverse()

    return teams
  }

  const getTeamBySlot = (slot, teams) => {
    if (!teams || teams.length === 0) return null

    let team = null
    teams.forEach(e => {
      if (e.players) {
        const player = e.players.find(p => p.slot === slot)
        if (player) {
          team = e.id
        }
      }
    })

    return team
  }

  return {
    // data
    paymentMethods,

    // mEthods
    fetchPaymentMethods,
    mapTeams,
    getTeamName,
    getTeamShield,
    getTeamBySlot,
  }
}
